import { put, takeEvery } from 'redux-saga/effects'
import { createBrowserHistory } from 'history'
import {
    CATEGORY_INIT_ACTION, CATEGORY_SUCCESS_ACTION,
    CATEGORY_FAIL_ACTION, FETCH_CATEGORY_INIT_ACTION,
    FETCH_CATEGORY_SUCCESS_ACTION,
    FETCH_CATEGORY_FAIL_ACTION,
    FETCH_CATEGORY_BYID_INIT_ACTION,
    FETCH_CATEGORY_BYID_FAIL_ACTION,
    FETCH_CATEGORY_BYID_SUCCESS_ACTION
} from './action'
import { push } from 'connected-react-router'
import { appConfig } from '../../config'
import { toast } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'

var history = createBrowserHistory()


function* addCatgrs(value) {
    // console.log("saga work", value.value)
    try {
        const token = localStorage.getItem('token')
        const formData = new FormData();
        formData.append('name', 'icon')
        formData.append(
            "icon",
            value.value.iconurl,
            value.value.iconurl.name
        );

        const res = yield fetch(`${appConfig.ip}images/icon/add`, {
            method: 'POST',
            headers: {
                Authorization: `Bearer ${token}`
            },
            body: formData
        })
        if (!res.ok) {
            throw res;
        } else {

            const resJSON = yield res.json()
            const data = {
                name: value.value.name,
                desc: value.value.desc,
                code: value.value.code,
                parentCode: null,
                parent: value.value.parent,
                isActive: value.value.isActive,
                iconUrl: resJSON.files
            }
            const Categry = yield fetch(`${appConfig.ip}catgrs`, {
                method: 'POST',
                headers: {
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                    Authorization: `Bearer ${token}`
                },
                body: JSON.stringify(data)
            })
            if (!Categry.ok) {

            } else {
                const categryJSON = yield Categry.json()
                yield put({
                    type: CATEGORY_SUCCESS_ACTION,
                    payload: categryJSON
                })
            }

        }
    } catch (err) {
        if (err.ok === false) {
            yield put({
                type: CATEGORY_FAIL_ACTION,
                error: err
            })
        }
    }
}
function* fetchCatgrys() {
    try {
        const token = localStorage.getItem('token')
        const res = yield fetch(`${appConfig.ip}catgrs?parent=true`, {
            method: 'GET',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                Authorization: `Bearer ${token}`
            },

        })

        if (!res.ok) {
            throw res;
        } else {

            const resJSON = yield res.json()
            yield put({
                type: FETCH_CATEGORY_SUCCESS_ACTION,
                payload: resJSON
            })
        }
    } catch (err) {
        if (err.ok === false) {
            yield put({
                type: FETCH_CATEGORY_FAIL_ACTION,
                error: err
            })
        }
    }
}
function* fetchCatgryById(item) {
    try {
        const token = localStorage.getItem('token')
        const res = yield fetch(`${appConfig.ip}catgrs/` + item.item.id, {
            method: 'GET',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                Authorization: `Bearer ${token}`
            },

        })

        if (!res.ok) {
            throw res;
        } else {

            const resJSON = yield res.json()
            yield put({
                type: FETCH_CATEGORY_BYID_SUCCESS_ACTION,
                payload: resJSON
            })
        }
    } catch (err) {
        if (err.ok === false) {
            yield put({
                type: FETCH_CATEGORY_BYID_FAIL_ACTION,
                error: err
            })
        }
    }
}

export function* CategoryActionWatcher() {
    yield takeEvery(CATEGORY_INIT_ACTION, addCatgrs)
    yield takeEvery(FETCH_CATEGORY_INIT_ACTION, fetchCatgrys)
    yield takeEvery(FETCH_CATEGORY_BYID_INIT_ACTION, fetchCatgryById)
}